/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketnotfounderror3Inputs */

const en_ticketnotfounderror3 = /** @type {(inputs: Ticketnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This ticket no longer exists.`)
};

const de_ticketnotfounderror3 = /** @type {(inputs: Ticketnotfounderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Ticket gibt es nicht mehr.`)
};

/**
* | output |
* | --- |
* | "This ticket no longer exists." |
*
* @param {Ticketnotfounderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketnotfounderror3 = /** @type {((inputs?: Ticketnotfounderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketnotfounderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketnotfounderror3(inputs)
	return de_ticketnotfounderror3(inputs)
});
export { ticketnotfounderror3 as "ticketNotFoundError" }